export default __webpack_public_path__ + "static/media/roboto-v20-latin-100.641943e2.svg";